// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--HvAiH","marquee":"a10a3f92e9--marquee--AUPCl","text":"a10a3f92e9--text--M0ayN"};